/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

'use es6';

import { useState, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const withHoverState = WrappedComponent => props => {
  const [isHovered, setIsHovered] = useState(false);
  const mouseEnterHandler = useCallback(() => {
    setIsHovered(true);
  }, []);
  const mouseLeaveHandler = useCallback(() => {
    setIsHovered(false);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    onMouseEnter: mouseEnterHandler,
    onMouseLeave: mouseLeaveHandler,
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      isHovered: isHovered
    }))
  });
};